export default "__VITE_ASSET__4d2248d1__"